import { Colors, Metrics, Heading4, Text } from '@origin-digital/style-guide';
import React from 'react';
import styled from 'styled-components';
import Layout from '../../../../components/Layout/Layout';

// @ts-ignore
import calculatorMetaData from '../../calculatorMetaData.json';
import { VerticalLayout, VerticalLayoutItem } from '../../../../components/Layout/VerticalLayout';

const Disclaimer = styled.div`
  background: ${Colors.WHITE};
  padding-top: ${Metrics.Spacing.P_Y_LG}px;

  a {
    font-size: ${Metrics.FontSizes.SMALL}px;
  }

  .textItem {
    max-width: 100%;
  }
`;

const Spacer = styled.div`
  height: ${Metrics.Spacing.P_Y_XS}px;
`;

export type CalculatorDisclaimerProps = {};

export class CalculatorDisclaimer extends React.Component<CalculatorDisclaimerProps> {
  private scrollMarker: React.RefObject<HTMLSpanElement>;

  constructor(props: CalculatorDisclaimerProps) {
    super(props, {});
    this.scrollMarker = React.createRef();
  }

  render() {
    return (
      <React.Fragment>
        <Disclaimer>
          <Layout min={['SM', 'MD', 'LG']} max={[]} paddingX={4} paddingY={4}>
            <span ref={this.scrollMarker} />
            <VerticalLayout>
              <Heading4 text={calculatorMetaData.disclaimer.title} marginBottom={true} />
              {calculatorMetaData.disclaimer.descriptions.map((section: any) => (
                <VerticalLayoutItem key={section}>
                  <Text overflow="normal" size="xs" color="grey80" markdown>
                    {section}
                  </Text>
                </VerticalLayoutItem>
              ))}
            </VerticalLayout>
          </Layout>
        </Disclaimer>
        <Spacer />
      </React.Fragment>
    );
  }

  scrollTo() {
    const markerSpan = this.scrollMarker.current;
    if (markerSpan) {
      window.scroll(0, markerSpan.offsetTop);
    }
  }
}
